export const apiBaseUrl = import.meta.env.VITE_ADMIN_API_BASE_URL || 'No-apiBaseUrl'
export const liveAppUrl = import.meta.env.VITE_LIVE_API_BASE_URL || 'No-liveAppUrl'
export const platform = import.meta.env.VITE_ADMIN_PLATFORM || 'No-platform'
export const backgroundColor = import.meta.env.VITE_BACKGROUND_COLOR || '#cdda18ff'
export const logo = import.meta.env.VITE_LOGO || '/xo-blanche.png'
export const title = import.meta.env.VITE_TITLE || ''

// if(platform === 'local') {
//   console.log('apiBaseUrl', apiBaseUrl)
//   console.log('liveAppUrl', liveAppUrl)
//   console.log('platform : ', platform)
//   console.log('backgroundColor : ', backgroundColor)
//   console.log('logo : ', logo)
//   console.log('title : ', title)
// }

  